// import React, { useState, useEffect } from 'react';
// import './BooksBarcode.css';
// import * as Constants from '../../Constant/constant';
// function BooksBarcode() {
//     const [showBooksBarcode, setShowBooksBarcode] = useState(true);
//     const [selectedBookTypeBarcode, setSelectedBookTypeBarcode] = useState('');
//     const [bookNoFrom, setBookNoFrom] = useState('');
//     const [bookNoTo, setBookNoTo] = useState('');
//     const [bookTypesBarcode, setBookTypesBarcode] = useState([]);
//     const [loadingBookTypesBarcode, setLoadingBookTypesBarcode] = useState(true);
//     const [errorBookTypesBarcode, setErrorBookTypesBarcode] = useState(null);

//     useEffect(() => {
//         const fetchBookTypes = async () => {
//             setLoadingBookTypesBarcode(true);
//             setErrorBookTypesBarcode(null);
//             try {
//                 const response = await fetch(Constants.API_PATH +'/book_type_data'); // Replace with your API endpoint
//                 if (!response.ok) {
//                     throw new Error('Failed to fetch book types');
//                 }
//                 const data = await response.json();
//                 setBookTypesBarcode(data);
//             } catch (error) {
//                 setErrorBookTypesBarcode(error.message);
//             } finally {
//                 setLoadingBookTypesBarcode(false);
//             }
//         };

//         fetchBookTypes();
//     }, []);

//     const handleBookTypeChangeBarcode = (e) => {
//         setSelectedBookTypeBarcode(e.target.value);
//     };

//     const handleBookNoFromChange = (e) => {
//         setBookNoFrom(e.target.value);
//     };

//     const handleBookNoToChange = (e) => {
//         setBookNoTo(e.target.value);
//     };

//     const handleGenerateBarcode = () => {
//         // Logic to generate barcodes based on selectedBookTypeBarcode, bookNoFrom, and bookNoTo
//         console.log('Generating barcodes for:', {
//             selectedBookTypeBarcode,
//             bookNoFrom,
//             bookNoTo,
//         });
//     };

//     return (
//         showBooksBarcode && (
//             <div className="books-barcode-section containernew">
//                 <nav className="breadcrumb">
//                     <a href="#" className="breadcrumb-link">Home</a> /
//                     <a href="#" className="breadcrumb-link">Library Management</a> /
//                     <span className="breadcrumb-current">Books Barcode</span>
//                 </nav>
//                 <h2 className="section-title">Books Barcode</h2>
//                 <div className="form-section">
//                     <div className="form-group">
//                         <label htmlFor="bookTypeBarcode" className="form-label">Book Type</label>
//                         <select
//                             id="bookTypeBarcode"
//                             className="form-select"
//                             value={selectedBookTypeBarcode}
//                             onChange={handleBookTypeChangeBarcode}
//                         >
//                             <option value="">--Select Book Type--</option>
//                             {loadingBookTypesBarcode ? (
//                                 <option disabled>Loading...</option>
//                             ) : errorBookTypesBarcode ? (
//                                 <option disabled>Error: {errorBookTypesBarcode}</option>
//                             ) : (
//                                 bookTypesBarcode.map((bookType) => (
//                                     <option key={bookType.id} value={bookType.id}>
//                                         {bookType.name}
//                                     </option>
//                                 ))
//                             )}
//                         </select>
//                     </div>
//                     <div className="form-group">
//                         <label htmlFor="bookNoFrom" className="form-label">Book No From</label>
//                         <input
//                             type="text"
//                             id="bookNoFrom"
//                             className="form-input"
//                             placeholder="Book No From"
//                             value={bookNoFrom}
//                             onChange={handleBookNoFromChange}
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label htmlFor="bookNoTo" className="form-label">Book No To</label>
//                         <input
//                             type="text"
//                             id="bookNoTo"
//                             className="form-input"
//                             placeholder="Book No To"
//                             value={bookNoTo}
//                             onChange={handleBookNoToChange}
//                         />
//                     </div>
//                 </div>
//                 <button className="generate-button" onClick={handleGenerateBarcode}>Generate</button>
//             </div>
//         )
//     );
// }

// export default BooksBarcode;

import React, { useState, useEffect } from 'react';
import './BooksBarcode.css';
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';

function BooksBarcode() {
    const [selectedBookTypeBarcode, setSelectedBookTypeBarcode] = useState('');
    const [bookNoFrom, setBookNoFrom] = useState('');
    const [bookNoTo, setBookNoTo] = useState('');
    const [bookTypesBarcode, setBookTypesBarcode] = useState([]);
    const [loadingBookTypesBarcode, setLoadingBookTypesBarcode] = useState(true);
    const [errorBookTypesBarcode, setErrorBookTypesBarcode] = useState(null);

    useEffect(() => {
        const fetchBookTypes = async () => {
            setLoadingBookTypesBarcode(true);
            setErrorBookTypesBarcode(null);
            try {
                const response = await fetch(Constants.API_PATH + '/book_type_data');
                if (!response.ok) throw new Error('Failed to fetch book types');
                const data = await response.json();
                setBookTypesBarcode(data);
            } catch (error) {
                setErrorBookTypesBarcode(error.message);
            } finally {
                setLoadingBookTypesBarcode(false);
            }
        };
        fetchBookTypes();
    }, []);

    const handleGenerateBarcode = () => {
        if (!selectedBookTypeBarcode || !bookNoFrom || !bookNoTo) {
            alert("Please fill all the fields.");
            return;
        }

        console.log('Generating barcodes for:', {
            selectedBookTypeBarcode,
            bookNoFrom,
            bookNoTo,
        });

        // Logic to generate/display barcodes can be implemented here
    };

    return (
        <div className="books-barcode-section containernew">
            {/* <nav className="breadcrumb">
                <a href="#" className="breadcrumb-link">Home</a> /
                <a href="#" className="breadcrumb-link">Library Management</a> /
                <span className="breadcrumb-current">Books Barcode</span>
            </nav> */}

            <h2 className="section-title">Books Barcode</h2>

            <div className="form-section">
                {/* Book Type Dropdown */}
                <div className="form-group">
                    <label htmlFor="bookTypeBarcode" className="form-label">Book Type</label>
                    <SearchableSelect
                        id="bookTypeBarcode"
                        className="form-select"
                        value={selectedBookTypeBarcode}
                        onChange={(e) => setSelectedBookTypeBarcode(e.target.value)}
                        options={bookTypesBarcode.map((bookType) => ({
                            value: bookType.id,
                            label: bookType.book_type_name
                        }))}
                        loading={loadingBookTypesBarcode}
                        placeholder="--Select Book Type--"
                        noOptionsMessage={errorBookTypesBarcode ? `Error: ${errorBookTypesBarcode}` : 'No results found'}
                    />
                </div>

                {/* Book No From */}
                <div className="form-group">
                    <label htmlFor="bookNoFrom" className="form-label">Book No From</label>
                    <input
                        type="text"
                        id="bookNoFrom"
                        className="form-input"
                        placeholder="Book No From"
                        value={bookNoFrom}
                        onChange={(e) => setBookNoFrom(e.target.value)}
                    />
                </div>

                {/* Book No To */}
                <div className="form-group">
                    <label htmlFor="bookNoTo" className="form-label">Book No To</label>
                    <input
                        type="text"
                        id="bookNoTo"
                        className="form-input"
                        placeholder="Book No To"
                        value={bookNoTo}
                        onChange={(e) => setBookNoTo(e.target.value)}
                    />
                </div>
            </div>

            {/* Generate Button */}
            <button className="generate-button" onClick={handleGenerateBarcode}>
                Generate
            </button>
        </div>
    );
}

export default BooksBarcode;
